import { Outlet } from 'react-router-dom';
import { Heading } from './Heading';

export function Layout() {
  return (
    <div className='Layout'>
      <Heading />
      <Outlet />
    </div>
  )
}
